import Task from '@/common/models/task.model';
import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';

const tasksActions: CommonActionTree<any> = {
  socket_tasks({ commit }, data) {
    commit('CHANGE', { item: new Task(data) });
  }
};

const tasksGetters: CommonGetterTree<any> = {
  getItems: state => Object.values(state.itemsMap),
  isCreatingS3: (_state, getters) => getters.findItemByProps({ name: TaskName.S3_CREATE, state: TaskState.RUNNING }),
  installingUpdates: (_state, getters) => getters.findItemByProps({ name: TaskName.UPDATES_START, state: TaskState.RUNNING }),
};

export default new class implements CommonStore<any, Task> {
  name = 'tasks';
  resource = '/api/v2/tasks';
  Model = Task;
  singular = task => task;
  plural = tasks => tasks;
  getters = tasksGetters;
  actions = tasksActions;
}();
